module.exports = __webpack_public_path__ + "static/img/balogo01.58f55c5.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/balogo01.png
// module id = +H8H
// module chunks = 26